import React from 'react';

export const User = ({ user }) => <div>{user && user.name}</div>;
